// src/pages/monthlySalaryReport/components/exportMonthlySalaryReportCsv.js

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum = (val) => Number(val || 0).toFixed(2);

/**
 * @param {object} params
 * @param {Array}  params.list     - from Redux state.monthlySalaryReport.list
 * @param {object} params.filters  - { month, year }
 * @param {string} params.title
 * @param {string} params.filename
 */
export const exportMonthlySalaryReportCsv = ({
  list,
  filters,
  title    = "Monthly Salary Payable Report",
  filename = "monthly_salary_report",
}) => {
  const rows = [[title], []];

  const headers = [
    "No.", "Name", "Department", "Designation",
    "Salary", "Attendance", "Leave With Pay", "Deduction",
    "Conveyance", "MA", "TA", "DA",
    "Others Commission", "Sales Amount", "Commission %",
    "Sales Commission", "Flight Ticket", "Paid", "Payable",
  ].map(escape);

  rows.push(headers);

  // Data rows
  list.forEach((row, i) => {
    rows.push([
      i + 1,
      row.name           || "",
      row.department     || "",
      row.designation    || "",
      fmtNum(row.salary),
      row.attendance     ?? 0,
      row.leave_with_pay ?? 0,
      fmtNum(row.deduction),
      fmtNum(row.conveyance),
      fmtNum(row.ma),
      fmtNum(row.ta),
      fmtNum(row.da),
      fmtNum(row.others_commission),
      fmtNum(row.sales_amount),
      row.commission_percent ?? "",
      fmtNum(row.sales_commission),
      fmtNum(row.flight_ticket),
      fmtNum(row.paid),
      fmtNum(row.payable),
    ].map(escape));
  });

  // Grand total row
  const totals = list.reduce(
    (acc, row) => {
      acc.salary             += Number(row.salary)             || 0;
      acc.attendance         += Number(row.attendance)         || 0;
      acc.leave_with_pay     += Number(row.leave_with_pay)     || 0;
      acc.deduction          += Number(row.deduction)          || 0;
      acc.conveyance         += Number(row.conveyance)         || 0;
      acc.ma                 += Number(row.ma)                 || 0;
      acc.ta                 += Number(row.ta)                 || 0;
      acc.da                 += Number(row.da)                 || 0;
      acc.others_commission  += Number(row.others_commission)  || 0;
      acc.sales_amount       += Number(row.sales_amount)       || 0;
      acc.commission_percent += Number(row.commission_percent) || 0;
      acc.sales_commission   += Number(row.sales_commission)   || 0;
      acc.flight_ticket      += Number(row.flight_ticket)      || 0;
      acc.paid               += Number(row.paid)               || 0;
      acc.payable            += Number(row.payable)            || 0;
      return acc;
    },
    {
      salary: 0, attendance: 0, leave_with_pay: 0, deduction: 0,
      conveyance: 0, ma: 0, ta: 0, da: 0, others_commission: 0,
      sales_amount: 0, commission_percent: 0, sales_commission: 0,
      flight_ticket: 0, paid: 0, payable: 0,
    }
  );

  rows.push([]); // spacer
  rows.push([
    "Grand Total", "", "", "",
    fmtNum(totals.salary),
    totals.attendance,
    totals.leave_with_pay,
    fmtNum(totals.deduction),
    fmtNum(totals.conveyance),
    fmtNum(totals.ma),
    fmtNum(totals.ta),
    fmtNum(totals.da),
    fmtNum(totals.others_commission),
    fmtNum(totals.sales_amount),
    totals.commission_percent,
    fmtNum(totals.sales_commission),
    fmtNum(totals.flight_ticket),
    fmtNum(totals.paid),
    fmtNum(totals.payable),
  ].map(escape));

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};